/**
 * @typedef {import('@/types/promotionTypes.js').SegmentDetails} SegmentDetails
 */

import {Tag} from '@/components-v2'

/**
 * @typedef {Object} SegmentTagsProps
 * @property {SegmentDetails[]} segments - Array of segment details to display as tags
 * @property {(segment: SegmentDetails) => void} handleTagRemove - Callback to handle tag removal
 * @property {string} color - Color of the tag
 * @property {string} separator - Optional text displayed between tags
 */

/**
 * Component for displaying segment tags
 * @param {SegmentTagsProps} props
 */
export const SegmentTags = ({segments, handleTagRemove, color = 'default', separator = ''}) => {
  return (
    <div className="mb-4 mt-4 flex flex-row flex-wrap items-center gap-2">
      {segments?.length > 0 &&
        segments?.map((seg, index) => {
          return (
            <div key={seg.segmentId} className="flex flex-row flex-wrap items-center gap-2">
              <Tag
                id={seg.segmentId}
                text={seg.segmentName}
                isRemovable={true}
                color={color}
                onRemove={() => handleTagRemove(seg)}
              />
              {separator && index < segments.length - 1 && (
                <span className="text-sm font-medium text-white">{separator}</span>
              )}
            </div>
          )
        })}
    </div>
  )
}
